export default {
  'zh-CN': {
    newbieTask: {
      sectionTitle: '完成新手任务领取奖励',
      allCompleted: '新手任务已全部完成',
      noTasks: '暂无任务',
      debugTitle: 'API 调试',
      clear: '清空',
      noLogs: '暂无日志',
      pull: {
        idle: '下拉刷新',
        release: '松开刷新',
        loading: '刷新中...',
        success: '刷新完成',
        failed: '刷新失败'
      },
      rewardStatus: {
        claimed: '已领取',
        obtained: '已获得',
        locked: '未解锁'
      },
      claimAction: '领取',
      taskButton: {
        completed: '已完成',
        done: '去完成',
        tips: '提示'
      },
      mockTasks: [
        '完成首次对话',
        '设置个性签名',
        '分享给好友',
        '上传头像',
        '编辑昵称',
        '开启应用通知',
        '发送第一个表情',
        '收听一次语音回复',
        '将芙崽加入常用',
        '打开一次咒语面板',
        '解锁一个奖励心形',
        '阅读隐私政策',
        '查看用户服务协议',
        '浏览个人信息清单',
        '浏览第三方共享清单',
        '打开数据删除说明'
      ]
    }
  },
  en: {
    newbieTask: {
      sectionTitle: 'Complete newbie tasks for rewards',
      allCompleted: 'All beginner tasks completed',
      noTasks: 'No tasks available',
      debugTitle: 'API Debug',
      clear: 'Clear',
      noLogs: 'No logs yet',
      pull: {
        idle: 'Pull to refresh',
        release: 'Release to refresh',
        loading: 'Refreshing...',
        success: 'Refresh complete',
        failed: 'Refresh failed'
      },
      rewardStatus: {
        claimed: 'Claimed',
        obtained: 'Obtained',
        locked: 'Locked'
      },
      claimAction: 'Claim',
      taskButton: {
        completed: 'Completed',
        done: 'Done',
        tips: 'Tips'
      },
      mockTasks: [
        'Complete first conversation',
        'Set your personal signature',
        'Share with a friend',
        'Upload your avatar',
        'Edit your nickname',
        'Enable app notifications',
        'Send your first emoji',
        'Listen to one voice reply',
        'Pin Fuzozo to your favorites',
        'Open the spell panel once',
        'Unlock a reward heart',
        'Read the privacy policy',
        'Check the user agreement page',
        'Visit the personal info list',
        'Visit the third-party sharing list',
        'Open data deletion instructions'
      ]
    }
  },
  ja: {
    newbieTask: {
      sectionTitle: '初心者タスクを完了して報酬を獲得',
      allCompleted: '初心者タスクはすべて完了しました',
      noTasks: '利用可能なタスクはありません',
      debugTitle: 'API デバッグ',
      clear: 'クリア',
      noLogs: 'ログはまだありません',
      pull: {
        idle: '引っ張って更新',
        release: '離して更新',
        loading: '更新しています...',
        success: '更新完了',
        failed: '更新に失敗しました'
      },
      rewardStatus: {
        claimed: '受取済み',
        obtained: '獲得済み',
        locked: '未解放'
      },
      claimAction: '受け取る',
      taskButton: {
        completed: '完了',
        done: '実行',
        tips: 'ヒント'
      },
      mockTasks: [
        '最初の会話を完了する',
        '個性署名を設定する',
        '友だちに共有する',
        'アバターをアップロードする',
        'ニックネームを編集する',
        'アプリ通知を有効にする',
        '最初の絵文字を送信する',
        '音声返信を1回聞く',
        'Fuzozo をお気に入りに追加する',
        '呪文パネルを1回開く',
        '報酬ハートを1つ解放する',
        'プライバシーポリシーを読む',
        '利用規約ページを確認する',
        '個人情報一覧を見る',
        '第三者共有一覧を見る',
        'データ削除案内を開く'
      ]
    }
  },
  'zh-TW': {
    newbieTask: {
      sectionTitle: '完成新手任務領取獎勵',
      allCompleted: '新手任務已全部完成',
      noTasks: '暫無任務',
      debugTitle: 'API 除錯',
      clear: '清空',
      noLogs: '暫無日誌',
      pull: {
        idle: '下拉刷新',
        release: '放開刷新',
        loading: '刷新中...',
        success: '刷新完成',
        failed: '刷新失敗'
      },
      rewardStatus: {
        claimed: '已領取',
        obtained: '已獲得',
        locked: '未解鎖'
      },
      claimAction: '領取',
      taskButton: {
        completed: '已完成',
        done: '去完成',
        tips: '提示'
      },
      mockTasks: [
        '完成首次對話',
        '設定個性簽名',
        '分享給好友',
        '上傳頭像',
        '編輯暱稱',
        '開啟應用通知',
        '發送第一個表情',
        '收聽一次語音回覆',
        '將芙崽加入常用',
        '打開一次咒語面板',
        '解鎖一個獎勵愛心',
        '閱讀隱私政策',
        '查看使用者服務協議',
        '瀏覽個人資訊清單',
        '瀏覽第三方共享清單',
        '打開資料刪除說明'
      ]
    }
  }
}
